import { getConfiguration } from '@chr/common-web-ui-configuration';
import { AppConfig, UserProfile } from '@chr/online-shared-microsite-core';
import { initialize } from 'launchdarkly-js-client-sdk';
import { FeatureFlags } from './constants';

export const retrieveFeatureFlags = async (userProfile: UserProfile): Promise<FeatureFlags> => {
  const config = await getConfiguration<AppConfig>();

  const userKey: string = userProfile?.userId.toString();

  const user = {
    key: userKey,
    anonymous: false,
    kind: 'user',
  };

  const options = {
    allAttributesPrivate: true,
  };

  const ldClient = initialize(config.launchDarklyClientId, user, options);

  await ldClient.waitForInitialization();

  return ldClient.allFlags();
};
